import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '~/common/utils';
import * as css from './input.module.scss';
export const Errors = ({ errors, className }) => {
    if (errors.length === 1) {
        return (_jsxs("span", { className: cx(css.errors, className), "aria-label": "form-error", children: [_jsx("span", { className: "kw kw-alert-octagon" }), _jsxs("span", { children: [" ", errors[0]] })] }));
    }
    return (_jsxs("div", { className: cx(css.multipleErrors, className), "aria-label": "form-error", children: [_jsx("span", { className: cx('kw kw-alert-octagon', css.errorIcon) }), _jsx("ul", { className: cx(css.errors), children: errors.map((error, key) => (_jsx("li", { children: error }, key))) })] }));
};
